import { render, staticRenderFns } from "./hsnCode.vue?vue&type=template&id=6c4b3e84&scoped=true&"
import script from "./hsnCode.vue?vue&type=script&lang=js&"
export * from "./hsnCode.vue?vue&type=script&lang=js&"
import style0 from "./hsnCode.vue?vue&type=style&index=0&id=6c4b3e84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4b3e84",
  null
  
)

export default component.exports